export default {
  meta: {
    title: '商铺详情'
  }
};
